import PageHero from "@/components/shared/PageHero";
import BlogsSection from "@/components/sections/BlogsSection";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";

export default function BlogsPage() {
  return (
    <div data-testid="page-blogs">
      <PageHero
        eyebrow="Blogs"
        title={<>Insights from the <span className="italic text-bronze">ground floor.</span></>}
        sub="Field notes, strategies, and quiet observations from working with Singapore homeowners and investors."
        image={ASSETS.lifestyle.livingRoom}
        ctas={[
          { label: "WhatsApp Kiap", href: BRAND.whatsapp, variant: "primary" },
          { label: "Use Calculators", to: "/resources/calculators", variant: "secondary" },
        ]}
        meta={[
          { label: "Cadence", value: "Weekly" },
          { label: "Categories", value: "5 topics" },
          { label: "Reading", value: "5–10 min" },
        ]}
      />
      <BlogsSection withHeading={false} />
      <CTASection />
    </div>
  );
}
